(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[373],{

/***/ 63258:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nha-tuyen-dung/[companyName]",
      function () {
        return __webpack_require__(7786);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96306);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_CompanyDetail__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25021);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13448);





var CompanyDetailPage = function(props) {
    var jsToken = props.jsToken, wsToken = props.wsToken, user = props.user, companyProfile = props.companyProfile, appMode = props.appMode, isRobot = props.isRobot, companyJobs = props.companyJobs, infoPath = props.infoPath, metaHead = props.metaHead, companyOCIData = props.companyOCIData, seoKeywords = props.seoKeywords;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var query = router.query;
    var companyName = query && typeof query.companyName === "object" ? query.companyName.join(",") : query.companyName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_store__WEBPACK_IMPORTED_MODULE_3__.AppStoreProvider, {
        langCode: _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_4__/* .ELanguage.VI */ .Df.VI,
        isRobot: isRobot,
        companyJobs: companyJobs,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CompanyDetail__WEBPACK_IMPORTED_MODULE_2__["default"], {
            seoKeywords: seoKeywords,
            jsToken: jsToken,
            wsToken: wsToken,
            user: user,
            appMode: appMode,
            langCode: _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_4__/* .ELanguage.VI */ .Df.VI,
            companyName: companyName || "",
            companyProfile: companyProfile,
            infoPath: infoPath,
            companyOCIData: companyOCIData,
            isCLP: false,
            metaHead: metaHead
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (CompanyDetailPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [22,775,362,239,326,918,61,448,452,21,774,888,179], function() { return __webpack_exec__(63258); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);